import { useMutation } from "@apollo/client";
import { AppBar, IconButton, Toolbar } from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import mypaps_logo from "assets/icons/MYPAPSLOGO.svg";
import papsChristmasLogo from "assets/icons/MyPaps_Noel_White.svg";
import defaultimageuser from "assets/images/defaultimageuser.svg";
import { Menu } from "components/Menu";
import { NotificationPopUp } from "components/NotificationPopUp";
import { Profil } from "components/Profil";
import useText from "constants/text";
import { useAlertDispatch } from "contexts/AlertContext";
import { READ_NOTIFICATIONS } from "domains/Notification/graphql/mutation";
import { COUNT_NOTIFICATION_BADGE } from "domains/Notification/graphql/queries";
import { EPlatform, Profile_User } from "generated/graphql";
import { useCurrentClient, useCurrentUser } from "hooks";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "styled-components/macro";
import { STATUS_CODE } from "../../utils/status";
import FullScreenDialog from "./ResponsiveMenu";
import { useApBarStyles } from "./styles";

export function AppNavbar() {
  const { text } = useText();
  const styles = useApBarStyles();
  const setAlert = useAlertDispatch();
  const { user } = useCurrentUser();
  const { client } = useCurrentClient();
  const navigation = useNavigate();
  const [showNotificationPopUp, setShowNotificationPopUp] = useState(false);
  const logo = process.env.REACT_APP_PAPS_GIFT === "true" ? papsChristmasLogo : mypaps_logo;
  const [readNotification] = useMutation(READ_NOTIFICATIONS);
  const [toggleMenu, setToggleMenu] = React.useState(false);

  const toggleNav = () => {
    setToggleMenu(!toggleMenu);
  };

  const handleReadingNotification = () => {
    !showNotificationPopUp &&
      readNotification({
        variables: {
          viewer: user?._id,
          viewerPlatform: user?.company_user_clientId,
          platform: EPlatform.Client,
        },
        refetchQueries: [
          {
            query: COUNT_NOTIFICATION_BADGE,
            variables: { viewerId: user?._id, viewerPlatform: user?.company_user_clientId, platform: EPlatform.Client },
          },
        ],
      })
        .then((result) => {
          if (result.data?.updateNotificationViewer?.code !== STATUS_CODE.OK)
            setAlert({ severity: "error", message: text.all.read_notification_error });
        })
        .catch((error) => setAlert({ severity: "error", message: text.all.read_notification_error }));
    setShowNotificationPopUp(!showNotificationPopUp);
  };
  return (
    <div
      style={{
        flexGrow: 1,
      }}
    >
      <AppBar position="fixed" className={styles.root}>
        <Toolbar className={styles.toolbar}>
          <div className={styles.left}>
            <IconButton
              edge="start"
              className={styles.menuButton}
              color="inherit"
              aria-label="menu"
              onClick={toggleNav}
            >
              <MenuIcon />
            </IconButton>
            <IconButton
              onClick={() => {
                navigation("/");
              }}
            >
              <img src={logo} alt="paps logo" style={{ maxWidth: "150px" }} />
            </IconButton>
            <div className={styles.menu}>{client && <Menu ranking={client?.ranking} />}</div>
          </div>
          <div className={styles.right}>
            {process.env.REACT_APP_NOTIFICATION_SKIP_CHECK === "false" && (
              <div>
                <NotificationPopUp
                  popit={showNotificationPopUp}
                  onClick={() => {
                    handleReadingNotification();
                    // setShowNotificationPopUp(!showNotificationPopUp);
                  }}
                  onClickItem={() => {
                    navigation("/notification");
                  }}
                />
              </div>
            )}

            <div className={styles.bagde}>
              <Profil
                user={user?.company_user_picture_url ?? defaultimageuser}
                admin={user?.company_user_profil === Profile_User.Admin}
                accountName={`${user?.company_user_firstname} ${user?.company_user_lastname}`}
                companyName={client?.client_company_name}
              />
            </div>
          </div>
        </Toolbar>
      </AppBar>

      <FullScreenDialog open={toggleMenu} handleClose={toggleNav} />
    </div>
  );
}

export default AppNavbar;
